//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable vuejs-accessibility/alt-text */
import {
  ref, computed, getCurrentInstance,
} from '@vue/composition-api'
import { mdiClose, mdiContentCopy, mdiCheck } from '@mdi/js'
import { useUtils } from '@core/libs/i18n'
import useCryptoJs from '@core/utils/useCryptoJs'
import { success, error } from '@core/utils/toasted'
import { useClipboard } from '@vueuse/core'
import { copyText } from 'vue3-clipboard'
import { isMobile } from '@core/utils'
import {
  SEmail, SSms, SWhatsApp, STwitter, STelegram,
} from 'vue-socials'

export default {
  name: 'Share',
  components: {
    SEmail,
    SSms,
    SWhatsApp,
    STwitter,
    STelegram,
  },
  model: {
    prop: 'isOpen',
    event: 'update:is-open',
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    link: {
      type: String,
      require: true,
      default: '',
    },
    iconSize: {
      type: Number,
      default: 24,
    },
    date: {
      type: String,
      require: true,
      default: '',
    },
    startTime: {
      type: String,
      require: true,
      default: '',
    },
    location: {
      type: String,
      require: true,
      default: '',
    },
    sport: {
      type: String,
      require: true,
      default: '',
    },
    shareTeams: {
      type: Boolean,
      require: false,
      default: false,
    },
    teamA: {
      type: String,
      require: false,
      default: '??',
    },
    teamB: {
      type: String,
      require: false,
      default: '??',
    },
    teamPlayersA: {
      type: Array,
      require: false,
      default: () => ['??', '??', '??', '??', '??'],
    },
    teamPlayersB: {
      type: Array,
      require: false,
      default: () => ['??', '??', '??', '??', '??'],
    },
  },
  setup(props, { emit }) {
    const { t } = useUtils()
    const { userData } = useCryptoJs()
    const { copy, isSupported } = useClipboard()
    const vm = getCurrentInstance().proxy

    const refVCopy = ref(null)
    const refCopy = ref(null)
    const isCopied = ref(false)

    const computedIsMobile = computed(() => isMobile())

    const computedDate = computed(() => props.date)
    const computedStartTime = computed(() => props.startTime)
    const computedLocation = computed(() => props.location)
    const computedSport = computed(() => props.sport)
    const computedLink = computed(() => props.link)

    const windowFeatures = ref({})
    const useNativeBehavior = ref(false)

    const computedText = computed(() => {
      const {
        teamA, teamB, teamPlayersA, teamPlayersB, shareTeams,
      } = props

      let text = `${computedSport.value}\n${computedDate.value} ${computedStartTime.value}\n${computedLocation.value}\n\nJoin here ${computedLink.value}`
      if (shareTeams) text = `*${computedSport.value.toUpperCase()} TEAM CHALLENGE*\n📅 ${computedDate.value}, ${computedStartTime.value}\n📍 ${computedLocation.value}\n🛡️ *${teamA}* vs. 🛡️ *${teamB}*\n\n*JOIN HERE:* ${computedLink.value}\n\n🛡️ *${teamA}*\n${teamPlayersA.map((player, index) => `${index + 1}. ${player !== '??' ? '✅' : '🔲'} ${player}`).join('\n')}\n\n🛡️ *${teamB}*\n${teamPlayersB.map((player, index) => `${index + 1}. ${player !== '??' ? '✅' : '🔲'} ${player}`).join('\n')}`

      return text
    })

    const computedTextWs2 = computed(() => {
      const {
        teamA, teamB, teamPlayersA, teamPlayersB, shareTeams,
      } = props

      let text = `Date: ${computedDate.value}\nTime: ${computedStartTime.value}\nLocation: ${computedLocation.value}\n\nVideo recording available via the link.\n\nManage booking:\n${computedLink.value}`
      if (shareTeams) text = `*${computedSport.value.toUpperCase()} TEAM CHALLENGE*\n📅 ${computedDate.value}, ${computedStartTime.value}\n📍 ${computedLocation.value}\n🛡️ *${teamA}* vs. 🛡️ *${teamB}*\n\n*JOIN HERE:* ${computedLink.value}\n\n🛡️ *${teamA}*\n${teamPlayersA.map((player, index) => `${index + 1}. ${player !== '??' ? '✅' : '🔲'} ${player}`).join('\n')}\n\n🛡️ *${teamB}*\n${teamPlayersB.map((player, index) => `${index + 1}. ${player !== '??' ? '✅' : '🔲'} ${player}`).join('\n')}`

      return text
    })

    const computedTextWs = computed(() => {
      const {
        teamA, teamB, teamPlayersA, teamPlayersB, shareTeams,
      } = props

      let text = `${computedSport.value}\n${computedDate.value} ${computedStartTime.value}\n${computedLocation.value}\n\nJoin here ${computedLink.value}`
      if (shareTeams) text = `*${computedSport.value.toUpperCase()} TEAM CHALLENGE*\n📅 ${computedDate.value}, ${computedStartTime.value}\n📍 ${computedLocation.value}\n🛡️ *${teamA}* vs. 🛡️ *${teamB}*\n\n*JOIN HERE:* ${computedLink.value}\n\n🛡️ *${teamA}*\n${teamPlayersA.map((player, index) => `${index + 1}. ${player !== '??' ? '✅' : '🔲'} ${player}`).join('\n')}\n\n🛡️ *${teamB}*\n${teamPlayersB.map((player, index) => `${index + 1}. ${player !== '??' ? '✅' : '🔲'} ${player}`).join('\n')}`

      return text
    })

    const computedEmail = computed(() => {
      const body = {
        mail: '',
        cc: [],
        bcc: [],
        subject: 'Fanaty',
        body: computedText.value,
      }

      return body
    })

    const computedSms = computed(() => {
      const body = {
        number: '',
        body: computedText.value,
      }

      return body
    })

    const computedWs = computed(() => {
      const body = {
        number: '',
        text: computedTextWs.value,
      }

      return body
    })

    const computedFb = computed(() => {
      const body = {
        url: `${computedLink.value}`,
        quote: computedText.value,
        hashtag: '#Fanaty',
      }

      return body
    })

    const computedTw = computed(() => {
      const body = {
        url: `${computedLink.value}`,
        text: computedText.value,
        hashtags: [],
        via: '',
      }

      return body
    })

    const computedTl = computed(() => {
      const body = {
        url: `${computedLink.value}`,
        text: computedText.value,
      }

      return body
    })

    const computedIsOpen = computed({
      set: val => emit('update:is-open', val),
      get: () => props.isOpen,
    })

    const onSave = () => {
      emit('onSave')
    }

    const onClose = () => {
      console.log('onClose')
    }

    const onOpen = () => {
      console.log('onOpen')
    }

    const onBlock = () => {
      console.log('onBlock')
    }

    const onFocus = () => {
      console.log('onFocus')
    }

    const successCopy = () => {
      setTimeout(() => {
        success(vm.$t('tooltip.copied'))
        isCopied.value = true

        setTimeout(() => {
          isCopied.value = false
          refVCopy.value.onBlur()
        }, 2000)
      }, 500)
    }

    const copyToClipboard = () => {
      const el = document.querySelector('#refCopy')

      if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        const editable = el.contentEditable
        const { readOnly } = el

        el.contentEditable = true
        el.readOnly = true

        const range = document.createRange()
        range.selectNodeContents(el)

        const selection = window.getSelection()
        selection.removeAllRanges()
        selection.addRange(range)
        el.setSelectionRange(0, 999999)

        el.contentEditable = editable
        el.readOnly = readOnly
      } else {
        el.select()
      }

      document.execCommand('copy')
      successCopy()
    }

    const copyTextAction = () => {
      copyText(refCopy.value.value, undefined, e => {
        if (e) {
          error(vm.$t('tooltip.not_copy'))
        } else {
          success(vm.$t('tooltip.copied'))
        }
      })
    }

    const copyAction = () => {
      if (!isSupported) {
        copyToClipboard()
      } else if (!isCopied.value) {
        copy(props.link).then(() => {
          successCopy()
        })
      }
    }

    return {
      // data
      userData,
      refCopy,
      refVCopy,
      isCopied,
      computedIsMobile,

      windowFeatures,
      useNativeBehavior,

      computedDate,
      computedStartTime,
      computedLocation,
      computedSport,

      computedTextWs2,

      computedEmail,
      computedSms,
      computedWs,
      computedFb,
      computedTw,
      computedTl,

      // computed
      computedIsOpen,

      // methods
      onSave,
      copyAction,
      copyTextAction,
      copyToClipboard,

      onClose,
      onOpen,
      onBlock,
      onFocus,

      // i18n
      t,

      // icons
      icons: {
        mdiClose,
        mdiContentCopy,
        mdiCheck,
      },
    }
  },
}
